"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Requester = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _constants = require("./constants"),
  _types = require("./types"),
  _logging = require("../logging");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Requester = /*#__PURE__*/function () {
  function Requester(a) {
    _classCallCheck(this, Requester);
    var b = a.urlProvider,
      c = a.packageInfo,
      d = a.externalRequester,
      e = a.requestTimeout,
      f = a.trackRetryDelay,
      g = a.useAbortController;
    _defineProperty(this, "externalRequester", void 0), _defineProperty(this, "urlProvider", void 0), _defineProperty(this, "packageInfo", void 0), _defineProperty(this, "trackRetryDelay", void 0), _defineProperty(this, "useAbortController", void 0), _defineProperty(this, "timeout", void 0), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: new Requester(urlProvider, packageInfo: ", ", externalRequester, requestTimeout: ", ", trackRetryDelay: ", ", useAbortController: ", ")"])), c, e, f, g), this.urlProvider = b, this.useAbortController = g, this.externalRequester = d, this.trackRetryDelay = f, this.packageInfo = c, this.timeout = e, _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: new Requester(urlProvider, packageInfo: ", ", externalRequester, requestTimeout: ", ", trackRetryDelay: ", ", useAbortController: ", ")"])), c, e, f, g);
  }
  return _createClass(Requester, [{
    key: "getClientConfiguration",
    value: function () {
      var _getClientConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(a) {
        var b, c, d, _a, e, _d, _a2, _b;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              b = this.urlProvider.getClientConfigurationUrl(a), c = _defineProperty2(_defineProperty2({}, _constants.Header.SdkType, this.packageInfo.type.toLowerCase()), _constants.Header.SdkVersion, this.packageInfo.version), d = _constants.NUMBER_OF_RETRIES + 1;
              _context.prev = 1;
              _a = {
                message: ""
              };
              _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Running configuration request Method: ", ", Url: ", ", Headers: ", ", with retry limit ", ", retry delay ", " ms"])), _types.HttpMethod.Get, b, c, d, this.trackRetryDelay);
              e = 0;
            case 5:
              if (!(e < d)) {
                _context.next = 28;
                break;
              }
              _context.next = 8;
              return this.sendRequest({
                url: b,
                requestType: _types.RequestType.Configuration,
                retryCount: e,
                parameters: {
                  method: _types.HttpMethod.Get,
                  headers: c
                }
              });
            case 8:
              _d = _context.sent;
              if (!_d.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 12;
              return _d.json();
            case 12:
              _a2 = _context.sent;
              return _context.abrupt("return", (_logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["Received configuration response: ", " for request Method: ", ", Url: ", ", Headers: ", ""])), {
                status: _d.status
              }, _types.HttpMethod.Get, b, c), (0, _tsRes.Ok)(_a2)));
            case 14:
              if (!(e === _constants.NUMBER_OF_RETRIES)) {
                _context.next = 23;
                break;
              }
              if (!_d.text) {
                _context.next = 20;
                break;
              }
              _context.next = 18;
              return _d.text();
            case 18:
              _b = _context.sent;
              _a = JSON.parse(_b);
            case 20:
              _logging.KameleoonLogger.error(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["Failed to get configuration response ", " for request Method: ", ", Url: ", ", Headers: ", ""])), {
                status: _d.status,
                message: _a.message
              }, _types.HttpMethod.Get, b, c);
              _context.next = 25;
              break;
            case 23:
              _context.next = 25;
              return this.logRequestError({
                logLevel: _logging.LogLevel.WARNING,
                message: "Failed to get configuration response",
                response: _d,
                method: _types.HttpMethod.Get,
                url: b
              });
            case 25:
              e++;
              _context.next = 5;
              break;
            case 28:
              return _context.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.MaximumRetriesReached, _a.message)));
            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](1);
              _context.next = 35;
              return this.logRequestError({
                logLevel: _logging.LogLevel.ERROR,
                message: "Failed to get configuration response",
                error: _context.t0,
                method: _types.HttpMethod.Get,
                url: b,
                headers: c
              });
            case 35:
              return _context.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.ClientConfiguration, _context.t0)));
            case 36:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 31]]);
      }));
      function getClientConfiguration(_x) {
        return _getClientConfiguration.apply(this, arguments);
      }
      return getClientConfiguration;
    }()
  }, {
    key: "getRemoteData",
    value: function () {
      var _getRemoteData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(a) {
        var b, _a3, c, _b2, _d2, d;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              b = this.urlProvider.getRemoteDataUrl(a);
              _logging.KameleoonLogger.debug(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["Running remote data request Method: ", ", Url: ", ""])), _types.HttpMethod.Get, b);
              _context2.prev = 2;
              _context2.next = 5;
              return this.sendRequest({
                url: b,
                requestType: _types.RequestType.RemoteData,
                retryCount: 0,
                parameters: {
                  method: _types.HttpMethod.Get
                }
              });
            case 5:
              _a3 = _context2.sent;
              if (_a3.ok) {
                _context2.next = 16;
                break;
              }
              _context2.next = 9;
              return this.logRequestError({
                logLevel: _logging.LogLevel.ERROR,
                message: "Failed to get remote data response",
                response: _a3,
                method: _types.HttpMethod.Get,
                url: b
              });
            case 9:
              if (!_a3.text) {
                _context2.next = 15;
                break;
              }
              _context2.next = 12;
              return _a3.text();
            case 12:
              _b2 = _context2.sent;
              _d2 = null === (c = JSON.parse(_b2)) || void 0 === c ? void 0 : c.message;
              return _context2.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, _d2)));
            case 15:
              return _context2.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, "Unknown Reason - no `text()` was found for a response")));
            case 16:
              _context2.next = 18;
              return _a3.json();
            case 18:
              d = _context2.sent;
              return _context2.abrupt("return", (_logging.KameleoonLogger.debug(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["Received remote data response: ", " for request Method: ", ", Url: ", ""])), {
                status: _a3.status
              }, _types.HttpMethod.Get, b), (0, _tsRes.Ok)(d)));
            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](2);
              _context2.next = 26;
              return this.logRequestError({
                logLevel: _logging.LogLevel.ERROR,
                message: "Failed to get remote data response",
                error: _context2.t0,
                method: _types.HttpMethod.Get,
                url: b
              });
            case 26:
              return _context2.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, _context2.t0)));
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 22]]);
      }));
      function getRemoteData(_x2) {
        return _getRemoteData.apply(this, arguments);
      }
      return getRemoteData;
    }()
  }, {
    key: "getVisitorData",
    value: function () {
      var _getVisitorData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(a) {
        var b, c, d, e, _a4, _b3, f, _a5, _b4;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              b = a.visitorCode, c = a.filters, d = a.isMappingIdentifier;
              e = this.urlProvider.getVisitorDataUrl({
                visitorCode: b,
                filters: c,
                isMappingIdentifier: d
              });
              _logging.KameleoonLogger.debug(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["Running visitor data request Method: ", ", Url: ", ""])), _types.HttpMethod.Get, e);
              _context3.prev = 3;
              _context3.next = 6;
              return this.sendRequest({
                url: e,
                requestType: _types.RequestType.RemoteData,
                retryCount: 0,
                parameters: {
                  method: _types.HttpMethod.Get
                }
              });
            case 6:
              _a4 = _context3.sent;
              if (_a4.ok) {
                _context3.next = 18;
                break;
              }
              _context3.next = 10;
              return this.logRequestError({
                logLevel: _logging.LogLevel.ERROR,
                message: "Failed to get visitor data response",
                response: _a4,
                method: _types.HttpMethod.Get,
                url: e
              });
            case 10:
              if (!("function" == typeof _a4.text)) {
                _context3.next = 17;
                break;
              }
              _context3.next = 13;
              return _a4.text();
            case 13:
              _b3 = _context3.sent;
              if (!_b3) {
                _context3.next = 17;
                break;
              }
              _a5 = null === (f = JSON.parse(_b3)) || void 0 === f ? void 0 : f.message;
              return _context3.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, _a5)));
            case 17:
              return _context3.abrupt("return", _a4.status ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, "No error message. Error status: ".concat(_a4.status))) : (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, "Unknown Reason - no text message or error status was found for a response")));
            case 18:
              _context3.next = 20;
              return _a4.json();
            case 20:
              _b4 = _context3.sent;
              return _context3.abrupt("return", (_logging.KameleoonLogger.debug(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["Received visitor data response: ", " for request Method: ", ", Url: ", ""])), {
                status: _a4.status
              }, _types.HttpMethod.Get, e), (0, _tsRes.Ok)(_b4)));
            case 24:
              _context3.prev = 24;
              _context3.t0 = _context3["catch"](3);
              _context3.next = 28;
              return this.logRequestError({
                logLevel: _logging.LogLevel.ERROR,
                message: "Failed to get visitor data response",
                error: _context3.t0,
                method: _types.HttpMethod.Get,
                url: e
              });
            case 28:
              return _context3.abrupt("return", (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RemoteData, _context3.t0)));
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 24]]);
      }));
      function getVisitorData(_x3) {
        return _getVisitorData.apply(this, arguments);
      }
      return getVisitorData;
    }()
  }, {
    key: "track",
    value: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(a, b) {
        var _this = this;
        var c, d, _e, _b5;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              c = _constants.NUMBER_OF_RETRIES + 1, d = this.urlProvider.getTrackingUrl(b);
              _logging.KameleoonLogger.debug(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["Running tracking request Method: ", ", Url: ", ", Body: ", ", with retry limit ", ", retry delay ", " ms"])), _types.HttpMethod.Post, d, a, c, this.trackRetryDelay);
              _e = 0;
            case 3:
              if (!(_e < c)) {
                _context4.next = 24;
                break;
              }
              _b5 = void 0;
              _context4.prev = 5;
              _context4.next = 8;
              return this.sendRequest({
                url: d,
                retryCount: _e,
                requestType: _types.RequestType.Tracking,
                parameters: {
                  body: a,
                  method: _types.HttpMethod.Post
                }
              });
            case 8:
              _b5 = _context4.sent;
              if (!_b5.ok) {
                _context4.next = 11;
                break;
              }
              return _context4.abrupt("return", (_logging.KameleoonLogger.debug(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["Received tracking response: ", " for request Method: ", ", Url: ", ", Body: ", ""])), {
                status: _b5.status
              }, _types.HttpMethod.Post, d, a), (0, _tsRes.Ok)()));
            case 11:
              _context4.next = 13;
              return this.logRequestError({
                logLevel: _logging.LogLevel.WARNING,
                message: "Failed to get tracking response",
                response: _b5,
                method: _types.HttpMethod.Post,
                url: d
              });
            case 13:
              _context4.next = 19;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](5);
              _context4.next = 19;
              return this.logRequestError({
                logLevel: _logging.LogLevel.WARNING,
                message: "Failed to get tracking response",
                error: _context4.t0,
                method: _types.HttpMethod.Post,
                url: d
              });
            case 19:
              _context4.next = 21;
              return new Promise(function (a) {
                return setTimeout(a, _this.trackRetryDelay);
              });
            case 21:
              _e++;
              _context4.next = 3;
              break;
            case 24:
              return _context4.abrupt("return", (_logging.KameleoonLogger.error(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["Failed to get tracking response for request Method: ", ", Url: ", ""])), _types.HttpMethod.Post, d), (0, _tsRes.Err)()));
            case 25:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[5, 15]]);
      }));
      function track(_x4, _x5) {
        return _track.apply(this, arguments);
      }
      return track;
    }()
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(a) {
        var b, c, d, e, f, _a6, g;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              c = a.url, d = a.requestType, e = a.retryCount, f = a.parameters;
              if (!this.useAbortController) {
                _context5.next = 9;
                break;
              }
              _a6 = new AbortController(), g = setTimeout(function () {
                return _a6.abort();
              }, this.timeout);
              _context5.next = 5;
              return this.externalRequester.sendRequest({
                url: c,
                retryCount: e,
                requestType: d,
                parameters: _objectSpread(_objectSpread({}, f), {}, {
                  signal: _a6.signal
                })
              });
            case 5:
              b = _context5.sent;
              clearTimeout(g);
              _context5.next = 12;
              break;
            case 9:
              _context5.next = 11;
              return this.externalRequester.sendRequest({
                url: c,
                retryCount: e,
                requestType: d,
                parameters: f
              });
            case 11:
              b = _context5.sent;
            case 12:
              return _context5.abrupt("return", b);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function sendRequest(_x6) {
        return _sendRequest.apply(this, arguments);
      }
      return sendRequest;
    }()
  }, {
    key: "logRequestError",
    value: function () {
      var _logRequestError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(a) {
        var b, c, d, e, f, g, h, _a7, _a8;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              b = a.logLevel, c = a.message, d = a.error, e = a.method, f = a.url, g = a.response, h = a.headers;
              if (!d) {
                _context6.next = 6;
                break;
              }
              _a7 = "Unknown error";
              d instanceof Error && (_a7 = d.message), _logging.KameleoonLogger.error(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["", " with error: ", " for request Method: ", ", Url: ", ""])), c, _a7, e, f);
              _context6.next = 11;
              break;
            case 6:
              if (!(g && _logging.KameleoonLogger.checkLevel(b))) {
                _context6.next = 11;
                break;
              }
              _context6.next = 9;
              return this.parseResponse(g);
            case 9:
              _a8 = _context6.sent;
              _logging.KameleoonLogger.log({
                level: b,
                strings: function strings() {
                  return "".concat(c, " response: Status: '").concat(_a8.status, "' Message: '").concat(_a8.message, "' for request Method: ").concat(e, ", Url: '").concat(f, "'") + (h ? ", Headers: ".concat(h) : "");
                }
              });
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function logRequestError(_x7) {
        return _logRequestError.apply(this, arguments);
      }
      return logRequestError;
    }()
  }, {
    key: "parseResponse",
    value: function () {
      var _parseResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(a) {
        var b, d, c;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              b = "";
              _context7.prev = 1;
              if (!("function" == typeof a.text)) {
                _context7.next = 7;
                break;
              }
              _context7.next = 5;
              return a.text();
            case 5:
              d = _context7.sent;
              if (d) {
                b = null === (c = JSON.parse(d)) || void 0 === c ? void 0 : c.message;
              }
            case 7:
              _context7.next = 11;
              break;
            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](1);
            case 11:
              return _context7.abrupt("return", {
                status: a.status,
                message: b
              });
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[1, 9]]);
      }));
      function parseResponse(_x8) {
        return _parseResponse.apply(this, arguments);
      }
      return parseResponse;
    }()
  }]);
}();
exports.Requester = Requester;